import React from 'react';
import Icon from '../../../components/AppIcon';
import StatusIndicator from '../../../components/ui/StatusIndicator';

const TimelineEvent = ({ status, label, timestamp, message, isCompleted, isActive, isLast }) => {
  const statusIcons = {
    depose: 'PackagePlus',
    stocke: 'Warehouse',
    charge_conteneur: 'Container',
    au_port_anvers: 'Anchor',
    bateau_parti: 'Ship',
    bateau_en_mer: 'Waves',
    arrive_abidjan: 'MapPin',
    douane: 'FileCheck',
    en_livraison: 'Truck',
    livre: 'CheckCircle'
  };

  const getStatusForIndicator = () => {
    if (isCompleted) return 'delivered';
    if (isActive) return 'in-transit';
    return 'pending';
  };

  return (
    <div className="relative flex items-start space-x-4 pb-8">
      {!isLast && (
        <div className={`absolute left-5 top-12 w-0.5 h-full ${
          isCompleted ? 'bg-success' : 'bg-border'
        }`} />
      )}
      <div className={`relative z-10 w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${
        isCompleted 
          ? 'bg-success text-white' 
          : isActive 
            ? 'bg-primary text-white animate-pulse-subtle' :'bg-muted text-muted-foreground'
      }`}>
        <Icon name={statusIcons?.[status] || 'Circle'} size={20} />
      </div>
      <div className="flex-1 min-w-0 pt-1">
        <div className="flex items-center justify-between flex-wrap gap-2 mb-2">
          <h4 className="text-base font-semibold text-foreground">{label}</h4>
          <StatusIndicator 
            status={getStatusForIndicator()} 
            size="sm"
            showIcon={false}
            label={label}
          />
        </div>
        
        {timestamp && (
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="Clock" size={14} className="text-muted-foreground" />
            <span className="text-sm text-muted-foreground">{timestamp}</span>
          </div>
        )}
        
        {message && (
          <div className="mt-3 p-3 bg-muted/50 rounded-md border border-border">
            <p className="text-sm text-foreground whitespace-pre-line">{message}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TimelineEvent;